export default __webpack_public_path__ + "static/media/GreyRectangleLeftSmallEllipse.7faab806.svg";